<template>
  <v-container fluid>
    <v-card>
      <v-card-title primary-title>
        <span class="headline mb-0">报价列表</span>
      </v-card-title>
      <v-card-text>
        <h3>处理Point</h3>
        <ol>
          <li>报价功能只限SJL用户和SHARP用户使用</li>
        </ol>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>
<style scoped>
</style>
